import { render } from "./InsuredProductsInformation.vue?vue&type=template&id=46705cb2"
import script from "./InsuredProductsInformation.vue?vue&type=script&lang=js"
export * from "./InsuredProductsInformation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__